// extracted by mini-css-extract-plugin
module.exports = {"eventos":"Eventos_eventos__3_52o","carregador":"Eventos_carregador__CmmAT","icone":"Eventos_icone__36kyH"};